import { useEffect } from 'react';
export default function useElementResizeObserver(elementRef, memoizedCallback) {
  useEffect(() => {
    const handleResizeObserver = new ResizeObserver(memoizedCallback);
    if (elementRef) {
      handleResizeObserver.observe(elementRef);
    }
    return () => handleResizeObserver.disconnect();
  }, [elementRef, memoizedCallback]);
}